module.exports = __webpack_public_path__ + "img/icon0.1428cbc4.png";